<script setup lang="ts">
const props = defineProps<{
  label: string
  content: string
  defaultOpen?: boolean
}>()

const isOpen = ref(props.defaultOpen || false)

onMounted(() => {
  if (window.location.hash === `#${props.label.toLowerCase().replace(/\s+/g, '-')}`) {
    isOpen.value = true
  }
})

function toggle() {
  isOpen.value = !isOpen.value
}
</script>

<template>
  <div
    class="self-stretch p-6 bg-[#192731] rounded-[20px] border border-white/10 backdrop-blur-md flex flex-col justify-center items-start overflow-hidden transition-all duration-300 cursor-pointer mb-4"
    @click="toggle"
  >
    <div class="self-stretch flex justify-between items-center gap-6">
      <div class="flex-1 text-white text-[13px] font-normal font-base uppercase leading-7 [text-shadow:0px_2px_6px_rgba(0,0,0,0.06)]">
        {{ label }}
      </div>
      <div class="w-6 h-6 flex items-center justify-center relative">
        <div
          class="w-4 h-0.5 bg-white transition-transform duration-300"
          :class="{ 'rotate-180': isOpen }"
        />
        <div
          class="w-4 h-[2px] bg-white absolute transition-transform duration-300"
          :class="isOpen ? 'rotate-180' : 'rotate-90'"
        />
      </div>
    </div>

    <div
      class="grid transition-[grid-template-rows] duration-300 ease-in-out self-stretch"
      :class="isOpen ? 'grid-rows-[1fr] mt-6' : 'grid-rows-[0fr]'"
    >
      <div class="overflow-hidden">
        <div class="text-white/60 text-[15px] font-normal font-base leading-5.25">
          {{ content }}
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
/* NB International is likely a custom font, ensuring it falls back gracefully */
.font-supercell {
  font-family: "Supercell-Magic", sans-serif;
}
</style>
